import { useEffect, useState } from "react";
import { Backend } from "../services/Backend";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import { Container } from "@mui/material";

export function DisclaimerPage() {
    const [content, setContent] = useState("");

    useEffect(() => {
        Backend.get("app-page/disclaimer")
            .then(res => {
                setContent(res.content);   
            })
    }, []);

    return <Container maxWidth="lg" className="my-5">
        <ReactQuill
            value={content}
            readOnly={true}
            theme={"bubble"}
        />
    </Container>
}